
<c-inspection-data
    :has-data    = "true"
    status       = "X"
    :show-header = "false"
    :height      = "height"
    :show-border = "true"
    :title       = "$t('disposition.images.menu')"
>
    <template v-slot:body>
        <div class="w-100 h-100 images-scroll">
            <input
                ref      = "fileInput"
                type     = "file"
                multiple
                hidden
                :accept  = "accept"
                @change  = "onFiles"
            />

            <div v-for="section in sections" :key="section.type" class="images-section">
                <div class="section-head">
                    <span class="section-title">{{ section.title }}</span>
                    <span class="section-count">{{ imagesOf(section.type).length }}</span>
                    <v-btn text small color="primary" :disabled="!inspection" @click="onUpload(section.type)">
                        <v-icon left small>mdi-upload</v-icon>
                        {{ section.upload }}
                    </v-btn>
                </div>

                <div v-if="imagesOf(section.type).length === 0" class="section-empty">
                    {{ $t('disposition.images.empty') }}
                </div>

                <div v-else class="strip">
                    <div
                        v-for = "(image, index) in imagesOf(section.type)"
                        :key  = "image.id"
                        class = "strip-item"
                        @click = "onSelect(section.type, index)"
                    >
                        <c-inspection-image
                            :inspection-id = "inspection.id"
                            :image-id      = "image.id"
                        />
                    </div>
                </div>
            </div>

            <img-lightbox
                v-if      = "lightbox"
                :images   = "imagesOf(lightbox)"
                :position.sync = "position"
                fullscreen
                @close    = "lightbox = null"
            />
        </div>
    </template>
</c-inspection-data>
